import ApiService from "./ApiService";

const ROOT_URL = "/services/authorization/api";

const AuthorizationApi = new ApiService(ROOT_URL, "", {
  authenticateUser: function(ctx, onSuccess, onError, formData) {
    this.apiPOSTFormData(
      ctx,
      "/authentication/authenticate",
      onSuccess,
      onError,
      formData
    );
  },
  getAllDomains: function(ctx, onSuccess, onError) {
    this.apiGET(ctx, "/subject/domains/getalldomains", onSuccess, onError);
  },
  fetchMenu: function(ctx, onSuccess, onError) {
    this.apiGET(ctx, "/subject/my/menus", onSuccess, onError);
  },
  captcha: function(ctx, onSuccess, onError) {
    this.apiGET(
      ctx,
      "/authentication/authenticate/" + ctx.username + "/generateCaptcha",
      onSuccess,
      onError
    );
  },
  searchDetailed: function(ctx, params, onSuccess, onError) {
    this.apiGET(
      ctx,
      "/subject/users/search/detailed",
      onSuccess,
      onError,
      params
    );
  },
  getUsers: function(ctx, onSuccess, onError) {
    this.apiGET(ctx, "/subject/users/detailed", onSuccess, onError);
  },
  createUser: function(ctx, data, onSuccess, onError) {
    this.apiPOST(ctx, "/subject/users", data, onSuccess, onError);
  },
  updateUser: function(ctx, id, data, onSuccess, onError) {
    this.apiPUT(ctx, `/subject/users/${id}`, data, onSuccess, onError);
  },
  deleteUser: function(ctx, id, onSuccess, onError) {
    this.apiDELETE(ctx, `/subject/users/${id}`, onSuccess, onError);
  },
  changeStatusToActiveUser: function(ctx, id, data , onSuccess, onError) {
    this.apiPUT(ctx, `/subject/users/${id}/status/active`,data, onSuccess, onError);
  },
  changeStatusToPassiveUser: function(ctx, id, data , onSuccess, onError) {
    this.apiPUT(ctx, `/subject/users/${id}/status/passive`,data, onSuccess, onError);
  },
  getProfiles: function(ctx, params, onSuccess, onError) {
    this.apiGET(ctx, "/authorization/profiles", onSuccess, onError, params);
  },
  createProfile: function(ctx, data, onSuccess, onError) {
    this.apiPOST(ctx, "/authorization/profiles", data, onSuccess, onError);
  },
  updateProfile: function(ctx, id, data, onSuccess, onError) {
    this.apiPUT(ctx, `/authorization/profiles/${id}`, data, onSuccess, onError);
  },
  deleteProfile: function(ctx, id, onSuccess, onError) {
    this.apiDELETE(ctx, `/authorization/profiles/${id}`, onSuccess, onError);
  },
  getRoles: function(ctx, params, onSuccess, onError) {
    this.apiGET(ctx, "/authorization/roles", onSuccess, onError, params);
  },
  updateRoles: function(ctx, id, data, onSuccess, onError) {
    this.apiPUT(
      ctx,
      `/authorization/profiles/${id}/roles`,
      data,
      onSuccess,
      onError
    );
  },
  revokeRoles: function(ctx, id, roleNamesArray, onSuccess, onError) {
    let url = `/authorization/profiles/${id}/roles?`;
    Array.prototype.forEach.call(roleNamesArray, (value, index) => {
      if (index + 1 == roleNamesArray.length && roleNamesArray.length > 1) {
        url += `roles=${value}&`;
      } else {
        url += `roles=${value}`;
      }
    });
    this.apiDELETE(ctx, url, onSuccess, onError);
  }
});
  
export default AuthorizationApi;



// WEBPACK FOOTER //
// ./src/service/AuthorizationService.js